import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

console.log('1. Index.js loaded');

// Error Boundary
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
    console.log('2. ErrorBoundary constructor');
  }

  static getDerivedStateFromError(error) {
    console.log('3. ErrorBoundary caught error:', error);
    return { hasError: true, error };
  }

  render() {
    console.log('4. ErrorBoundary render, hasError:', this.state.hasError);
    if (this.state.hasError) {
      return (
        <div style={{ padding: 40, background: 'red', color: 'white' }}>
          <h1>CRASHED: {this.state.error?.toString()}</h1>
        </div>
      );
    }
    return this.props.children;
  }
}

const rootElement = document.getElementById('root');
console.log('5. Root element:', rootElement);

if (rootElement) {
  const root = ReactDOM.createRoot(rootElement);
  console.log('6. About to render App');
  root.render(
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  );
  console.log('7. Render called');
} else {
  console.error('ROOT ELEMENT NOT FOUND!');
  document.body.innerHTML = '<h1 style="color:red">Root element not found!</h1>';
}